const Footer = () => (
  <div className='relative top-[81px] -mt-[81px] flex shrink-0 justify-center border-colorBorderSecondary border-t bg-colorBgLayout'>
    <footer className='flex w-full max-w-[1280px] flex-col-reverse flex-nowrap items-center justify-between p-8 font-semibold text-colorTextSecondary text-sm'>
      <div>FaceUp Technology s.r.o. &copy; {new Date().getFullYear()}</div>
    </footer>
  </div>
)

export default Footer
